export const LOGIN_USER = 'USER_LOGIN';
export const REGISTER_USER = 'USER_REGISTER';
export const LOG_OUT = 'LOG_OUT';
export const VERIFY_OTP = 'VERIFY_OTP';
export const RESEND_OTP = 'RESEND_OTP';
export const CHANGE_PASSWORD = 'CHANGE_PASSWORD';
export const RESET_PASSWORD = 'RESET_PASSWORD';
export const UPDATE_PROFILE_IMAGE = 'UPDATE_PROFILE_IMAGE';
export const SET_IMAGE_LOADING = 'SET_IMAGE_LOADING';
